import {
  RouterProvider as BaseRouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { PageDuitnowTest } from "../../../pages/duitnow-test";
import { FakedoorPage } from "../../../pages/fakedoor";
import { PaymentPage } from "../../../pages/payment";
import { ROUTES } from "../../../shared/routing/routing";

export const RouterProvider = () => {
  const router = createBrowserRouter([
    {
      element: <PaymentPage />,
      path: ROUTES.main,
    },
    {
      element: <FakedoorPage />,
      path: ROUTES.fakedoor,
    },
    {
      element: <PageDuitnowTest />,
      path: ROUTES.duitnow,
    },
  ]);

  return <BaseRouterProvider router={router} />;
};
